import React, { Fragment, useContext, useState } from 'react';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  Actions,
  WarningMessageModal,
  Tabs,
  BorderGradient,
  IconWithText,
  Belt,
  Helper,
  Button,
  ConfirmDelete,
} from 'Components';
import history from 'src/history';
import './JobsDesktopHeader.css';

const JobsDesktopHeader = (props) => {
  const { deletionState, dispatch } = useContext(DeletionContext);

  const { t } = useTranslation();
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);
  const handleProceed = () => {
    history.push('/submissions/new');
    setOpenWarningMessage(false);
  };
  const handleCancle = () => {
    setOpenWarningMessage(false);
  };
  const handlOnClick = () => {
    if (props.isSubmissionWarningON === 'ON') {
      setOpenWarningMessage(true);
    } else {
      history.push('/submissions/new');
    }
  };

  return (
    <Fragment>
      <div className="jobs-desktop-header">
        <Belt>
          <Helper text={t('tutorials:jobsTable.4')}>
            <Actions.UploadExcel onChange={props.onUpload} />
          </Helper>
          <Helper text={t('tutorials:jobsTable.5')}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              <IconWithText
                onClick={handlOnClick}
                icon="add_circle"
                text={i18n.t('jobs:NewJob')}
                textOrientation="before"
              />

              {deletionState.isDeletionModeActive ? (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                  }}
                >
                  <Button
                    className="button button--primary"
                    onClick={() => {
                      dispatch({
                        type: DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION,
                      });
                    }}
                    disabled={!(deletionState.selectedItems.length > 0)}
                  >
                    <span>{i18n.t('common:Delete')}</span>
                  </Button>
                  <Button
                    className="button button--primary"
                    onClick={() =>
                      dispatch({
                        type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE,
                      })
                    }
                  >
                    <span>{i18n.t('common:Cancel')}</span>
                  </Button>
                </div>
              ) : null}

              {deletionState.isDeleteConfirmationActive && (
                <ConfirmDelete
                  title={i18n.t('multiDeletion:MultiDeleteRecordsConfirmation')}
                  onCancelDelete={() => {
                    dispatch({
                      type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION,
                    });
                  }}
                  onProceedDelete={() => {
                    props.deleteSelectedItems(deletionState.selectedItems);
                    dispatch({
                      type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION,
                    });
                  }}
                />
              )}
            </div>
          </Helper>
        </Belt>

        <BorderGradient />

        <div className="jobs-desktop-header__tabs">
          <Tabs
            onClick={props.onTabsClick}
            tabs={props.tabs}
            labels={props.tabs.map((tab) => i18n.t(`jobs:${tab}`))}
            index={props.tabIndex}
            className="tabs__button"
          />
          <div className="jobs-desktop-header__tabs__actions">
            <Actions.ResultsPerPage value={props.pageSize} onChange={props.onPageSizeChange} />
          </div>
        </div>
        <div>
          {isWarningMessageOpen && (
            <WarningMessageModal onProceed={handleProceed} onCancel={handleCancle} section="Submission" />
          )}
        </div>
      </div>
    </Fragment>
  );
};

JobsDesktopHeader.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.string),
  tabIndex: PropTypes.number,
  pageSize: PropTypes.string,
  onTabsClick: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onUpload: PropTypes.func,
  isSubmissionWarningON: PropTypes.bool,
  deleteSelectedItems: PropTypes.func,
};

export default JobsDesktopHeader;



// WEBPACK FOOTER //
// ./src/containers/Jobs/JobsDesktop/JobsDesktopHeader/JobsDesktopHeader.jsx